import React from "react";
import { ComboRateChart } from "src/components/common/chart/ComboRateChart";
import { PRD5040_R01ResultDto } from "./Dto_PRD5040_R01";

// Chart 컴포넌트가 받는 props 타입
interface Props {
	data: PRD5040_R01ResultDto[]; // 월별(1~12월) 결과 리스트
}

// 월별 양품율 콤보차트 컴포넌트 (막대 2개 + 선 1개 공용 컴포넌트 사용)
export const Chart_PRD5040_R01: React.FC<Props> = ({ data }) => {
	return (
		<ComboRateChart
			data={data}
			barSeries={[
				{ field: "productQty", label: "생산수량", color: "#3B82F6" },
				{ field: "badQty", label: "불량수량", color: "#FB923C" },
			]}
			lineSeries={{ field: "yieldRate", label: "양품율", color: "#22C55E" }}
			y1={{ min: 90, max: 100, suffix: "%" }}
		/>
	);
};

export default Chart_PRD5040_R01;
